import { NgIf } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { UsersService } from '../services/users.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [MatToolbarModule, MatButtonModule, MatIconModule, MatMenuModule, NgIf, MatBadgeModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  private readonly authenticationService = inject(AuthenticationService);
  private readonly usersService = inject(UsersService);
  private readonly router = inject(Router);

  keycloakId: string = '';
  userInfo: any = {};

  profileImageUrl = '/src/assets/images/profile.png';
  showAvatar = true;

  // Badge notifiche
  notificationCount: number | null = 7;

  ngOnInit(): void {
    this.keycloakId = this.authenticationService.getKeycloakId();
    this.usersService.getLoggedUserInfo(this.keycloakId).subscribe((user)=> {
      this.userInfo = user
      console.log('userInfo', user);
    })
  }

  handleImageError(): void {
    // Fallback se l'immagine non carica
    this.profileImageUrl = 'assets/images/noavatar.png';
  }

  goToProfilePage(user: any){
    this.router.navigate(['/profile']);
  }

  logout(): void {
    console.log('esci');
    this.authenticationService.logout();
  }
}